import React, {
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import {
  Modal,
  Button,
  Flex,
} from "antd";
import {
  DownloadOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import moment from "moment";
import * as XLSX from "xlsx";
import DfLabelCard from "./DfLabelCard";
import { PendingTableCellContext } from "../../ChemBioPendingContext";

export function generateLabel(item) {
  const {
    genista_id, test, extracted_by, order_id,
  } = item;
  const commodityText = test.toLowerCase().includes("pesticide") ? `_${item.commodity ?? "-"}` : "";
  const initials = extracted_by ? extracted_by.split(" ").map((word) => word[0].toUpperCase()).join("") : "-";
  const baseLabel = `${order_id}_${genista_id}${commodityText}_${test}_DF_`;
  if (item.dilution_factors_list?.length > 0) {
    return item.dilution_factors_list.map((df) => `${baseLabel}${df}_${initials}`);
  }
  return [`${baseLabel}-_${initials}`];
}

const DfLabelModal = () => {
  const {
    showDfModal,
    handleCloseModal,
    selectedIds,
    markTestRunOnInstrument,
  } = useContext(PendingTableCellContext);

  const [labelData, setLabelData] = useState([]);
  const labelCardsRef = useRef(null);
  useEffect(() => {
    setLabelData(selectedIds.map((item) => ({
      ...item,
      labels: generateLabel(item),
    })));
    labelCardsRef.current = { loadings: selectedIds.map(() => false), submitted: 0 };
  }, [selectedIds]);

  const onModalClose = () => {
    const dataProcessing = labelCardsRef.current.loadings.find((processing) => processing);
    if (dataProcessing) {
      toast.warn("Please wait for the current process to finish.");
      return;
    }
    const refresh = labelCardsRef.current.submitted > 0;
    labelCardsRef.current = null;
    handleCloseModal(refresh);
  };

  const handleExport = () => {
    // Create a new workbook and a worksheet
    const excelData = [];
    labelData.forEach((item) => {
      const { labels } = item;
      labels.forEach((label) => {
        excelData.push({
          Label: label,
        });
      });
    });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `Labels_${moment(new Date()).format("MM/DD/YYYY_h:mm:ss_a")}.xlsx`);
  };

  return (
    <Modal
      centered
      destroyOnClose
      closable
      maskClosable={false}
      onCancel={() => onModalClose()}
      title={(
        <div className="PendingTable__DfModalTitle">
          <span>Labels</span>
          <Button icon={<DownloadOutlined />} type="link" onClick={handleExport}>Export</Button>
        </div>
      )}
      open={showDfModal}
      width="600px"
      footer={[]}
    >
      <Flex vertical>
        <div className="PendingTable__DfLabelContainer">
          {labelData.map((item, idx) => (
            <DfLabelCard key={idx} cardIdx={idx} item={item} labelCardsRef={labelCardsRef} markTestRunOnInstrument={markTestRunOnInstrument} />
          ))}
        </div>
      </Flex>
    </Modal>
  );
};

export default DfLabelModal;
